import Card from '../../../../shared/Card';

// TODO update/strikethrough/hide steps and Walkthrough when complete
export default function Help() {
  return (
    <Card>
      <div className="mt-4">
        <h4>Getting Started</h4>
        <ol>
          {/* TODO have user manually create the 'my values' list */}
          <li>
            Create a <strong>List</strong>
          </li>
          {/* TODO have user add items to the 'my values' list */}
          <li>
            Add <strong>Items</strong> to the List
          </li>
          {/* TODO have user compare items in the 'my values' list */}
          <li>
            <strong>Compare</strong> items
          </li>
          <li>
            View resulting <strong>Hierarchy</strong> display of items
          </li>
        </ol>
      </div>

      <div className="mt-4">
        <h4>Comparisons</h4>
        <p>
          When comparing items, you choose which one is more important to you.
          The specific criteria is up to you - you might be measuring
          importance, priority, value, or any other quality that matters to you.
        </p>
        <p>
          Each comparison creates a relationship between items. These
          relationships are used to organize your items into a hierarchy,
          helping you understand their relative importance.
        </p>
        <p>This is particularly useful for:</p>
        <ul>
          <li>Understanding your priorities</li>
          <li>Discovering your core values</li>
          <li>Organizing goals and tasks</li>
          <li>Making decisions</li>
          <li>Understanding preferences</li>
        </ul>
      </div>

      <div className="mt-4">
        <h4>Hierarchy</h4>
        <p>
          The hierarchy display shows your items organized by their
          relationships. Items that are consistently rated as more important
          appear higher in the hierarchy, while less important items appear
          lower.
        </p>
        <p>This visual organization helps you:</p>
        <ul>
          <li>See patterns in your priorities</li>
          <li>Identify your most important values</li>
          <li>Understand the relative importance of different items</li>
          <li>Make more informed decisions</li>
        </ul>
      </div>
    </Card>
  );
}
